import React, { useState, useEffect } from "react";
import logo from "../../kombu2.png";
import Superman from "./superman.svg";
import Tea from "./tea.svg";
import euro from "./express.svg";
import packagee from "./package.svg";
import multimedia from "./multimedia.svg";
import web from "./web.svg";
import blog from "./blog.svg";
import HeaderLink from "../HeaderLink";
import popUp from "../popUp";
function App(props) {
  const [sure, setSure] = useState(false);
  const [logout, setLogout] = useState(false);

  useEffect(() => {
    // Update the document title using the browser API
    if (logout) {
      window.localStorage.removeItem("token");
      props.setToken(null);
    }
  });
  return (
    <div
      style={{
        backgroundColor: "#1d1d1d",
        width: "220px",
      }}
    >
      {sure && (
        <div
          style={{
            position: "absolute",
            zIndex: "99",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#1d1d1d",
            opacity: "0.9",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#ecf0f1",
              width: "500px",
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              borderRadius: "2px",
              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
            }}
          >
            <div style={{ display: "flex" }}>
              <h5>Admin Panelden Cikmak Istediginize Emin Misiniz?</h5>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                onClick={() => setLogout(true)}
                style={{
                  cursor: "pointer",
                  width: "175px",
                  height: "40px",
                  backgroundColor: "#e74c3c",
                  display: "flex",
                  margin: "20px",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "5px",
                  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
                }}
              >
                <span style={{ color: "#fff", fontSize: "14px" }}>Evet </span>
              </div>
              <div
                onClick={() => setSure(false)}
                style={{
                  cursor: "pointer",

                  width: "175px",
                  height: "40px",
                  backgroundColor: "#2ecc71",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "5px",
                  margin: "20px",

                  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
                }}
              >
                <span style={{ color: "#fff", fontSize: "14px" }}>Hayir </span>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          margin: "0 auto",
          height: "100vh",
          display: "flex",
          width: "220px",
          backgroundColor: "#1d1d1d",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flex: "1",
            alignItems: "center",
            justifyContent: "flex-start",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            position: "sticky",
            top: "0px",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100px",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#efefef",
                marginBottom: "100px",
              }}
            >
              <img
                src={logo}
                width="200px"
                style={{ display: "flex" }}
                alt="kombuscoby.com"
              />
            </div>
          </div>
          <HeaderLink
            linkTo={"/users/list"}
            title={"Kullanıcılar"}
            icon={Superman}
          />
          <HeaderLink
            linkTo={"/allproducts/list"}
            title={"Ürünler"}
            icon={Tea}
          />
          <HeaderLink
            linkTo={"/orders/list"}
            title={"Siparişler"}
            icon={euro}
          />
          <HeaderLink
            linkTo={"/iade/list"}
            title={"İade Talepleri"}
            icon={packagee}
          />
          <HeaderLink
            linkTo={"/subscription/list"}
            title={"Mail Aboneleri"}
            icon={multimedia}
          />
          <HeaderLink linkTo={"/blog/list"} title={"Blog"} icon={blog} />

          <div
            onClick={() => setSure(true)}
            style={{
              display: "flex",
              flexDirection: "row",
              height: "50px",
              alignItems: "center",
              borderBottom: "1px solid #ebebeb",
              width: "60%",
              justifyContent: "flex-start",
            }}
          >
            <img style={{ display: "flex", width: "25px" }} src={web} />
            <span
              style={{
                display: "flex",
                fontSize: "16px",
                fontFamily: "Source Sans Pro",
                padding: 5,
                color: "white",
              }}
            >
              Çıkış Yap
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
